import { ModuleDetails } from '../../../../types/theory/module';
import { Alert, Button, Col, ProgressBar, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import usePurchase from '../../../../hooks/user/usePurchase';
import { useEffect, useState } from 'react';
import useModule from '../../../../hooks/theory/useModule';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LectureResponseEnhanced } from '../../../../types/theory/lecture';
import { ChapterResponse } from '../../../../types/theory/chapter';
import { useUser } from '../../../../hooks';

const ModuleProgress = ({ module }: { module: ModuleDetails }) => {
    const { t } = useTranslation();
    const { apiPurchaseSuccess, userPurchaseEntity } = usePurchase();
    const { userLoadModuleDetails, userModuleChapters } = useModule();
    const { isUserAuthenticated, loggedInUserRoles } = useUser();
    const [isRedirected, setIsRedirected] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (apiPurchaseSuccess) {
            userLoadModuleDetails(module.slug);
        }
    }, [apiPurchaseSuccess]);

    useEffect(() => {
        if (apiPurchaseSuccess && !isRedirected) {
            toast.success(t('module.lecture_loaded'), {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: 'colored',
                icon: '✔',
            });
            const firstLectureUrl = '/lectures/' + userModuleChapters?.[0].lectures?.[0].slug;
            navigate(firstLectureUrl);
            setIsRedirected(true);
        }
    }, [module]);

    const findLatestLecture = () => {
        let latestLecture: LectureResponseEnhanced = {
            id: 'N/A',
            title: 'N/A',
            slug: 'N/A',
            problemsFinished: false,
            quizFinished: false,
            canStart: false,
        };
        userModuleChapters?.forEach((chapter: ChapterResponse) => {
            chapter.lectures?.forEach((lecture) => {
                if (!lecture.problemsFinished && latestLecture.id === 'N/A') {
                    latestLecture = lecture;
                }
            });
        });
        toast.success(t('module.lecture_loaded'), {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: 'colored',
            icon: '✔',
        });
        const firstLectureUrl = '/lectures/' + latestLecture.slug;
        navigate(firstLectureUrl);
    };

    return (
        <Row>
            <Col xxl={1} md={2} sm={3} />
            <Col xxl={11} md={10} sm={9}>
                {isUserAuthenticated && (
                    <Row className='mt-2'>
                        <Col>
                            {module.isStarted && (
                                <Button className='fw-bolder border rounded-pill' size={'lg'} onClick={() => findLatestLecture()}>
                                    <span>{t('module.progress_continue')}</span>
                                </Button>
                            )}
                            {!module.isStarted && !module.isPremium && (
                                <Button className='fw-bolder border rounded-pill' size={'lg'} onClick={() => userPurchaseEntity({ model: 'modules', modelId: module.id })}>
                                    <span>{t('module.progress_new')}</span>
                                </Button>
                            )}
                            {!module.isStarted && module.isPremium && !loggedInUserRoles.includes('SUBSCRIBER') && (
                                <>
                                    <Button className='fw-bolder border rounded-pill float-start my-1' size={'lg'} disabled={true}>
                                        <span>{t('module.progress_new')}</span>
                                    </Button>
                                    <Alert variant={'warning'} className='my-0 float-start ms-2 fw-bold font-16 my-1'>
                                        <i className={'mdi mdi-alert me-2'} />
                                        {t('module.premium_warning')}
                                    </Alert>
                                </>
                            )}
                        </Col>
                    </Row>
                )}
                {module.userProgress > 0 && (
                    <Row className='mt-3'>
                        <Col>
                            <p className='mb-2 fw-bold text-uppercase'>
                                {t('module.progress')} <span className='float-end'>{Number(module.userProgress).toFixed(0)}%</span>
                            </p>
                            <ProgressBar now={module.userProgress} className='progress-sm' />
                        </Col>
                    </Row>
                )}
            </Col>
        </Row>
    );
};

export default ModuleProgress;
